import { graphql } from "../gql";

export const userQueryDoc = graphql(`
  query getUser($id: ID!) {
    user(id: $id) {
      ...UserFragment
    }
  }
`);
